import actionTypes from '../constants/action-types';

const updateExtension = (slug, updates) => ({
  type: actionTypes.UPDATE_EXTENSION,
  payload: {
    slug,
    updates,
  },
});

export default updateExtension;
